
@if (zones.length >= 2) {
	<div class="val-dashboard-navigation">
		@for (zone of zones; track zone.id) {
			<button class="val-dashboard-navigation-bouton"
					[ngClass]="{'val-dashboard-navigation-bouton-actif': zoneActive === zone.id}"
					(click)="ScrollVersZone(zone.id)">
				{{ zone.cleTraduction | transloco }}
			</button>
		}
	</div>
}
